<template>
  <HorizontalStackChart
    v-bind:title="title"
    v-bind:data="data"
    v-bind:labels="labels"
    v-bind:ratio="false"
  />
</template>

<script>
import HorizontalStackChart from "@/components/management/statistics/common/HorizontalStackChart";
import { getAccessByRecentModelChartData } from "@/api/statisticsV2";

export default {
  components: {
    HorizontalStackChart,
  },
  data() {
    return {
      title: "Access by Recent Model",
      data: [],
      labels: [],
    };
  },
  methods: {
    async getData() {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByRecentModelChartData();
        this.labels = response.data.name;
        this.data = response.data.data;
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style></style>
